import { useEffect, useState } from "react";
import { Card, Descriptions, Divider, Form, Modal, notification } from "antd";
import { CloseOutlined, CloudUploadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import moment from "moment";

import api from "../../../services/api";
import { formatarCpfCnpj, HasValue, novaAbaNavegador } from "../../../services/funcoes";
import { FormatNumber } from "../../../ValueObjects";
import { useStateValue } from "../../../state";

export default function ModalDavParaDfe({ dadosNota, exibirModal, fecharModal }) {
    const [{ dadosPdv }] = useStateValue();
    const [form] = Form.useForm();
    const [carregando, setCarregando] = useState(false);
    const [serieFiscal, setSerieFiscal] = useState();

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                form.resetFields();
                fecharModal();
            }
        });
    };

    const gerarNfe = async () => {
        setCarregando(true);

        let dados = {};
        dados.ser_id = dadosPdv?.pdv?.ser_id;
        dados.ntf_id = dadosNota.ntf_id;

        try {
            const retornoNF = await api.put(`NotaFiscal/GerarNotaFiscalDAV`, dados);
            if (retornoNF.status === 200) {
                if (retornoNF.data.ntf_status === 1 && !!retornoNF.data.ntf_chavenfe) {
                    notification.success({ message: 'Sucesso', description: `NF-e Autorizada com sucesso!` });
                    novaAbaNavegador(`Danfe/GerarDanfeNFCe?chaveNFe=${retornoNF.data.ntf_chavenfe}`);
                    let formaPagItegrado = retornoNF.data.notafiscalformapgtos.filter((item) => (HasValue(item.imp_id)))
                    if (formaPagItegrado.length > 0) {
                        novaAbaNavegador(`Danfe/GerarComprovantePagamentoViaLoja?IdNotaFiscal=${retornoNF.data.ntf_id}`);
                    }
                } else {
                    notification.error({ description: 'Não foi possível Autorizar nota fiscal! ' + retornoNF.data.ntf_xmotivo, message: `Aviso` });
                }
            } else {
                notification.error({ description: 'Não foi possível Autorizar nota fiscal!', message: `Aviso` });
            }
        }
        catch (erro) {
            if (!!erro.response && !!erro.response.data) {
                notification.error({ description: erro.response.data, message: `Aviso` });
            } else {
                notification.error({ description: 'Não foi possível Autorizar nota fiscal!', message: `Aviso` });
            }
            setCarregando(false);
        }
        finally {
            setCarregando(false);
            form.resetFields();
            fecharModal();
        }
        console.log(dadosNota)
    }

    useEffect(() => {
        if (!serieFiscal) {
            if (!!dadosPdv?.pdv) {
                api.get(`SerieFiscal/Buscar/${dadosPdv.pdv?.ser_id}`).then(
                    res => {
                        setSerieFiscal(res.data);
                    }
                ).catch(
                    error => {
                        console.log(error);
                    }
                )
            }
        }
    }, [dadosPdv])

    return (
        <Modal centered
            title="Gerar NFC-e"
            open={exibirModal}
            onCancel={onCloseModal}
            onOk={gerarNfe}
            confirmLoading={carregando}
            okText={
                <>
                    <CloudUploadOutlined /> Gerar NFC-e
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
            destroyOnClose
        >
            <Form layout="vertical" form={form}>
                <Card title="Informações da Nota" size="small" variant="borderless">
                    <Descriptions size="small">
                        <Descriptions.Item label={`Chave da `}>
                            <b> {dadosNota.ntf_chavenfe} </b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Destinatário">
                            <b> {dadosNota.ntf_nomedest ?? dadosNota.cta_razaosocial}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="CPF/CNPJ">
                            <b> {formatarCpfCnpj(dadosNota.ntf_cnpjcpfdest) ?? "NÃO INFORMADO"}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Nº da Nota">
                            <b>{dadosNota.ntf_numero}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="Emitida em">
                            <b>{moment(dadosNota.ntf_dataemissao).format('DD/MM/YYYY')}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Valor Total da Nota (R$)">
                            <b> {FormatNumber(dadosNota.valor_total, true)} </b>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                <Divider />

                <Card title="Configuração da NFC-e" size="small" variant="borderless">
                    <Descriptions size="small">
                        <Descriptions.Item label="Serie Fiscal">
                            <b> {serieFiscal?.ser_serie} </b>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            </Form>
        </Modal>
    )
}